import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { addToWishlist } from "../../store/slices/wishlist-slice";
import PropTypes from "prop-types";
import { Card, Flex } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaHeart } from "react-icons/fa6";
import { CiHeart } from "react-icons/ci";
import { addCart, getCartProducts } from "../../store/actions/cart-actions";
import BestProductModal from "./BestProductModal";
import { getProduct } from "../../store/actions/product-actions";

const BestProductGridSingle = ({
  product,
  currency,
  cartItem,
  wishlistItem,
  compareItem,
  spaceBottomClass,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("userauth");
  const isNew = product.new || true;

  const handleAddToCart = async () => {
    if (!isLoggedIn) {
      navigate("/login-register");
      return;
    }
    const formData = { productId: product._id };
    await dispatch(addCart(formData));
    await dispatch(getCartProducts());
    // window.location.reload();
  };

  const handleAddToWishlist = async () => {
    if (!isLoggedIn) {
      navigate("/login-register");
      return;
    }
    await dispatch(addToWishlist(product));
  };

  return (
    <div style={{ justifyItems: "center" }}>
      <Card
        className={`relative  max-w-[240px] overflow-hidden ${spaceBottomClass}`}
        style={{
          height: 407,
          width: 252,
          boxShadow:
            "0 4px 8px 0 rgba(0, 0, 0, 0.05), 0 6px 20px 0 rgba(0, 0, 0, 0.1)",
        }}
      >
        {isNew ? (
          <>
            <div
              style={{
                position: "absolute",
                left: "0px",
                top: "0px",
                width: 55,
                height: 25,
                zIndex: "10",
              }}
            >
              <span
                style={{
                  backgroundColor: "#2563eb",
                  color: "white",
                  fontSize: "0.75rem",
                  padding: "0.25rem 0.5rem",
                  borderRadius: "0.25rem",
                }}
              >
                NEW
              </span>
            </div>
          </>
        ) : (
          ""
        )}

        <button
          className="absolute right-2 top-2 z-10 p-1 rounded-full hover:bg-gray-100"
          onClick={handleAddToWishlist}
          disabled={wishlistItem !== undefined}
          // aria-label={wishlistItem !== undefined ? "Added to wishlist" : "Add to wishlist"}
          style={{
            position: "absolute",
            right: "0px",
            top: "0px",
            zIndex: "10",
            border: "none",
            background: "none",
          }}
        >
          {wishlistItem !== undefined ? (
            <FaHeart
              style={{
                position: "absolute",
                right: "0px",
                top: "0px",
                zIndex: "10",
                color: "green",
              }}
              onClick={handleAddToWishlist}
              disabled={wishlistItem !== undefined}
            />
          ) : (
            <CiHeart
              style={{
                position: "absolute",
                right: "4px",
                top: "4px",
                height: 24,
                width: 24,
                zIndex: "10",
                color: "green",
              }}
            />
          )}
        </button>
        <div
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="hover-img"
        >
          <Link to={`/product/${product._id}`}>
            <div className="aspect-[3/4] relative">
              <img
                src={product?.seriesImages[0]?.src || "https://09mobilegallery.com/assets/img/noimgavl.png"}
                onError={(e) => {
                  e.target.onerror = null; // prevents infinite loop if fallback also fails
                  e.target.src = "https://09mobilegallery.com/assets/img/noimgavl.png";
                }}
                alt={product?.name}
                style={{ height: 251, width: 200 }}
                className="hover-img"
              // className="object-cover w-full h-full rounded-t-lg"
              />
              {product.images.length > 1 ? (
                <img
                  className="hover-img"
                  src={product?.seriesImages[0]?.src || "https://09mobilegallery.com/assets/img/noimgavl.png"}
                  onError={(e) => {
                    e.target.onerror = null; // prevents infinite loop if fallback also fails
                    e.target.src = "https://09mobilegallery.com/assets/img/noimgavl.png";
                  }}
                  alt={product.name}
                  style={{ height: 251, width: 200 }}
                // className="object-cover w-full h-full rounded-t-lg"
                />
              ) : (
                ""
              )}
            </div>
          </Link>

          <div
            className="product-action"
            style={{
              opacity: isHovered ? 1 : 0,
              transition: "opacity 0.8s ease",
              display: "Flex",
              position: "absolute",
              marginLeft: "-24px",
              marginRight: "-24px",
              width: "251px",
              top: "245px",
              backgroundColor: "#fff",
            }}
          >
            {/* <div className="pro-same-action pro-wishlist" style={{borderBottomLeftRadius: "2vh", margin:"auto"}}>
              <button
                className={wishlistItem !== undefined ? "active" : ""}
                disabled={wishlistItem !== undefined}
                title={
                  wishlistItem !== undefined
                    ? "Added to wishlist"
                    : "Add to wishlist"
                }
                style={{backgroundColor:"white",borderRadius:"5px"}}
                onClick={async () => await dispatch(addToWishlist(product))}
                
              >
                <i className="pe-7s-like" />
              </button>
            </div> */}
            <div
              className="pro-same-action pro-cart"
              style={{ width: "49.5%", marginRight: "1%" }}
            >
              {product.status && product.status > 0 ? (
                <button
                  // onClick={() => dispatch(addToCart(product))}
                  onClick={handleAddToCart}
                  className={cartItem !== undefined ? "active" : ""}
                  disabled={cartItem !== undefined}
                  title={cartItem !== undefined ? "Added to bag" : "Add to bag"}
                  style={{
                    backgroundColor: "blue",
                    color: "white",
                    width: "100%",
                    padding: "5%",
                    border: "#fff",
                  }}
                >
                  {" "}
                  <i className="pe-7s-cart"></i>{" "}
                  {cartItem !== undefined ? "Added" : "Add to bag"}
                </button>
              ) : (
                <button disabled className="active">
                  Out of Stock
                </button>
              )}
            </div>
            <div
              className="pro-same-action pro-quickview"
              style={{ borderBottomRightRadius: "2vh", width: "49.5%" }}
            >
              <button
                title="Quick View"
                onClick={() => setModalShow(true)}
                style={{
                  backgroundColor: "blue",
                  width: "100%",
                  padding: "5%",
                  border: "#fff",
                }}
              >
                {/* <i className="pe-7s-look" /> */}
                <div style={{ color: "white" }}>Quick View</div>
              </button>
            </div>
          </div>
        </div>

        <div>
          <p style={{ fontWeight: 600, marginTop: 4 }}>
            <Link to={`/product/${product._id}`}>{product.name}</Link>
          </p>

          {/* <h3 className="font-medium">
            <Link to={`/product/${product._id}`}>
              {product.name}
            </Link>
          </h3> */}
          {/* <p className="text-sm text-muted-foreground">{product.shortDescription}</p> */}
        </div>
        <div style={{ position: "absolute", bottom: "24px" }}>
          <p style={{ color: "#5E5E5E", marginTop: -12 }}>
            {product.ram}GB | {product.storage}GB
          </p>
          <div style={{ marginTop: -15 }}>
            <span
              style={{
                marginTop: -18,
                fontWeight: 600,
                font: 15,
                fontSize: 18,
              }}
            >
              {"₹"}
              {product?.price}{" "}
            </span>
            <span
              className="old"
              style={{ textDecoration: "line-through", fontSize: 12 }}
            >
              {"₹" + product.mrp}
            </span>
            <span style={{ color: "red" }}> -{product.disPer}%</span>
            {/* <button
                onClick={handleAddToCart}
                disabled={cartItem !== undefined}
                className="text-sm font-medium text-blue-600 hover:text-blue-800 disabled:text-gray-400"
              >
                {cartItem !== undefined ? "Added to bag" : "Add to bag"}
              </button> */}
          </div>
        </div>
      </Card>

      <BestProductModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        product={product}
        discountedPrice={product.price}
        finalProductPrice={product.price}
        finalDiscountedPrice={product.price}
        wishlistItem={wishlistItem}
        compareItem={compareItem}
      />
    </div>
  );
};

BestProductGridSingle.propTypes = {
  compareItem: PropTypes.shape({}),
  product: PropTypes.shape({}),
  spaceBottomClass: PropTypes.string,
};

export default BestProductGridSingle;

// import { Fragment, useState } from "react";
// import PropTypes from "prop-types";
// import clsx from "clsx";
// import { Link, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import Rating from "./sub-components/ProductRating";
// import { getDiscountPrice } from "../../helpers/product";
// // import ProductModal from "./ProductModal";
// // import { addToCart } from "../../store/slices/cart-slice";
// import { addToWishlist } from "../../store/slices/wishlist-slice";
// import BestProductModal from "./BestProductModal";
// import { addCart, getCartProducts } from "../../store/actions/cart-actions";

// const BestProductGridSingle = ({
//   product,
//   currency,
//   cartItem,
//   // fastCartItems,
//   wishlistItem,
//   compareItem,
//   spaceBottomClass
// }) => {
//   const [modalShow, setModalShow] = useState(false);

//   const isNew = product.new || true;

//   const discountedPrice = getDiscountPrice(product.price, product?.disPer || 0);
//   const finalProductPrice = +(product.price);
//   const finalDiscountedPrice = +(
//     discountedPrice
//   );

//   const dispatch = useDispatch();
//   const navigate = useNavigate(); // Initialize navigate
//   // const isLoggedIn = useSelector((state) => state.user.user !== null);
//   const isLoggedIn = localStorage.getItem("userauth");
//   console.log("islogged in :", isLoggedIn);

// console.log("cart item : ", cartItem);

//   // const videoId = product.youtubeUrl.split('/shorts/')[1]?.split('?')[0] || '';

//   // const opts = {
//   //   height: '390',
//   //   width: '100%',
//   //   playerVars: {
//   //     autoplay: 1,
//   //     mute: 1,
//   //     loop: 1,
//   //     playlist: videoId
//   //   },
//   // };

//   // const onPlayerReady = (event) => {
//   //   event.target.playVideo();
//   // }

//   const handleAddToCart = async () => {
//     if (!isLoggedIn) {
//       navigate("/login-register");
//       return;
//     }

//     // Create the form data
//     const formData = {
//       productId: product._id
//     };

//     // Dispatch the addCart action with formData
//     await dispatch(addCart(formData));
//     await dispatch(getCartProducts());
//     window.location.reload();
//   };

//   return (
//     <Fragment>
//       <div className={clsx("product-wrap", spaceBottomClass)}>
//         <div className="product-img">
//           <Link to={process.env.PUBLIC_URL + "/product/" + product._id}>
//           {/* <YouTube videoId={videoId} opts={opts} onReady={onPlayerReady} /> */}
//               <img
//                 className="default-img"
//                 src={product.images[0]?.src || "/assets/img/noimgavl.png"}
//                 style={{borderRadius:"2vh"}}
//                 width={390}
//                 height={290}
//                 alt=""
//               />
// {product.images.length > 1 ? (
//   <img
//     className="hover-img"
//     src={product.images[1].src}  // it needs to 1 but the first is video so i change to 0
//     alt=""
//     width={390}
//     height={290}
//     style={{borderRadius:"2vh"}}
//   />
// ) : (
//   ""
// )}
//           </Link>
//           {product.disPer || isNew ? (
//             <div className="product-img-badges">
//               {product.disPer ? (
//                 <span className="pink">-{product.disPer}%</span>
//               ) : (
//                 ""
//               )}
//               {isNew ? <span className="purple">New</span> : ""}
//             </div>
//           ) : (
//             ""
//           )}

//   <div className="product-action">
//     <div className="pro-same-action pro-wishlist" style={{borderBottomLeftRadius: "2vh"}}>
//       <button
//         className={wishlistItem !== undefined ? "active" : ""}
//         disabled={wishlistItem !== undefined}
//         title={
//           wishlistItem !== undefined
//             ? "Added to wishlist"
//             : "Add to wishlist"
//         }
//         onClick={async () => await dispatch(addToWishlist(product))}

//       >
//         <i className="pe-7s-like" />
//       </button>
//     </div>
//     <div className="pro-same-action pro-cart">
//       {product.affiliateLink ? (
//         <a
//           href={product.affiliateLink}
//           rel="noopener noreferrer"
//           target="_blank"
//         >
//           {" "}
//           Buy now{" "}
//         </a>
//       ) : product.variation && product.variation.length >= 1 ? (
//         <Link to={`${process.env.PUBLIC_URL}/product/${product._id}`}>
//           Select Option
//         </Link>
//       ) : product.status && product.status > 0 ? (
//         <button
//           // onClick={() => dispatch(addToCart(product))}
//           onClick={handleAddToCart}
//           className={
//             cartItem !== undefined
//               ? "active"
//               : ""
//           }
//           disabled={cartItem !== undefined}
//           title={
//             cartItem !== undefined ? "Added to bag" : "Add to bag"
//           }
//         >
//           {" "}
//           <i className="pe-7s-cart"></i>{" "}
//           {cartItem !== undefined
//             ? "Added"
//             : "Add to bag"}
//         </button>
//       ) : (
//         <button disabled className="active">
//           Out of Stock
//         </button>
//       )}
//     </div>
//     <div className="pro-same-action pro-quickview" style={{borderBottomRightRadius: "2vh"}}>
//       <button title="Quick View" onClick={() => setModalShow(true)}>
//         <i className="pe-7s-look" />
//       </button>
//     </div>
//   </div>
// </div>
//         <div className="product-content text-center">
//           <h3>
//             <Link to={process.env.PUBLIC_URL + "/product/" + product._id}>
//               {product.name}
//             </Link>
//           </h3>
//           {/* {product.rating && product.rating > 0 ? (
//             <div className="product-rating">
//               <Rating ratingValue={product.rating} />
//             </div>
//           ) : (
//             ""
//           )} */}
//           <div className="product-price">
//             {/* {discountedPrice !== null ? (
//               <Fragment>
//                 <span>{"₹" + finalDiscountedPrice}</span>{" "}
//                 <span className="old">
//                   {"₹" + finalProductPrice}
//                 </span>
//               </Fragment>
//             ) : (
//               <span>{"₹" + finalProductPrice} </span>
//             )} */}
//             <span>
//                     {"₹ "+product.price}
//                   </span>{" "}
//                   <span className="old">
//                   {"₹ "+product.mrp}
//                 </span>
//           </div>
//         </div>
//       </div>
//       {/* product modal */}
//       <BestProductModal
//         show={modalShow}
//         onHide={() => setModalShow(false)}
//         product={product}
//         // bestprod={bestprod}
//         // currency={currency}
//         discountedPrice={discountedPrice}
//         finalProductPrice={finalProductPrice}
//         finalDiscountedPrice={finalDiscountedPrice}
//         wishlistItem={wishlistItem}
//         compareItem={compareItem}
//       />
//     </Fragment>
//   );
// };

// BestProductGridSingle.propTypes = {
//   // cartItem: PropTypes.shape({}),
//   compareItem: PropTypes.shape({}),
//   // wishlistItem: PropTypes.shape({}),
//   // currency: PropTypes.shape({}),
//   product: PropTypes.shape({}),
//   bestprod: PropTypes.shape({}),
//   sliderClassName: PropTypes.string,
//   spaceBottomClass: PropTypes.string,
// };

// export default BestProductGridSingle;
